/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EvaluationTypeEnum {
    E = 'E',
    V = 'V',
    C = 'C'
}

export function EvaluationTypeEnumFromJSON(json: any): EvaluationTypeEnum {
    return EvaluationTypeEnumFromJSONTyped(json, false);
}

export function EvaluationTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationTypeEnum {
    return json as EvaluationTypeEnum;
}

export function EvaluationTypeEnumToJSON(value?: EvaluationTypeEnum | null): any {
    return value as any;
}

